import type React from 'react'

import type { NavigationListState } from '../navigationListContext'
import { useNavigationListContext } from '../navigationListContext'

/**
 * Creates a keyboard event handler that will handle navigation keys
 * depending on the direction set on the NavigationList.
 */
export function makeKeyboardEventListenerForNavigationListState(
  navigationList: NavigationListState
) {
  return (event: React.KeyboardEvent) => {
    const nextKey =
      navigationList.direction === 'vertical' ? 'ArrowDown' : 'ArrowRight'
    const previousKey =
      navigationList.direction === 'vertical' ? 'ArrowUp' : 'ArrowLeft'
    if (event.key === nextKey) {
      event.preventDefault()
      navigationList.next()
    }
    if (event.key === previousKey) {
      event.preventDefault()
      navigationList.previous()
    }
  }
}

/**
 * This hook will handle keyboard events for a NavigationList. It can be used
 * both on items if they're focusable or on an external control input.
 * Beware, this handler will not focus the element after changing the selection.
 * Please refer to NavigationListItem for an example of how to achieve this.
 */
export function useNavigationListKeyboardEventHandler() {
  const navigationList = useNavigationListContext()

  return makeKeyboardEventListenerForNavigationListState(navigationList)
}
